import React from 'react'
import FirstContainer from './FirstContainer';
import SecondContainer from './SecondContainer';

const Home = () => {
  return (
    <div className="main-container">
        <FirstContainer/>
        <SecondContainer/>
    </div> 
  )
}

export default Home
